import { render } from "./gpStatusForm.vue?vue&type=template&id=5248f465"
import script from "./gpStatusForm.vue?vue&type=script&lang=js"
export * from "./gpStatusForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__